import { useState } from 'react';
import PropTypes from 'prop-types';
import StyleAuxiliary from 'hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import Icon from '../../../components/UI/MDC/Icon/Icon';
import Styles from './ExtendText.module.scss';

/**
 *
 * @param {string} text This is the text you want to be displayed
 * @param {Number} maxLength This is the max length of the text you want displayed while collapsed
 * @param {function} textClickHandler This is a function which gets executed if upon clicking on the expanded text
 * @returns ExtendText component returns collapsed text with a 3 dot indicator next to it to allow for expansion
 */
export const ExtendText = ({ text, maxLength, textClickHandler }) => {
	const [displayShowMore, setDisplayShowMore] = useState(true);

	return (
		<>
			{text ? (
				text.length < maxLength || !displayShowMore ? (
					<span
						className={Styles['text--tn--default']}
						onClick={() =>
							displayShowMore
								? setDisplayShowMore(false)
								: textClickHandler?.()
						}
					>
						{text}
					</span>
				) : (
					<StyleAuxiliary classes={Styles.box}>
						<span
							className={Styles['text--tn--default']}
							onClick={() =>
								displayShowMore
									? setDisplayShowMore(false)
									: textClickHandler?.()
							}
						>
							{text.slice(0, maxLength)}
						</span>
						<Icon
							className={Styles.icon}
							onClick={() => setDisplayShowMore(false)}
							color='primary'
							icon='more_horiz_alt'
						/>
					</StyleAuxiliary>
				)
			) : (
				text
			)}
		</>
	);
};

export const ExtendTextPropTypes = {
	text: PropTypes.string,
	maxLength: PropTypes.number,
};
